import classNames from 'classnames';

import { usePromotions } from '../../contexts/PromotionsContext';
import PromotionVerticalCard from '../cards/PromotionVerticalCard';
import GridList from '../lists/GridList';
import SectionTitle from '../typography/SectionTitle';

import styles from '../../styles/panels/account-panel.module.css';

interface AccountPromotionsPanelProps {
    className?: string;
}

function AccountPromotionsPanel({ className = null }: AccountPromotionsPanelProps) {
    const { promotions = [] } = usePromotions();
    const filteredPromotions = (promotions || []).filter(
        ({ placement }) => placement === 'account',
    );

    return (
        <div className={classNames([styles.container, className])}>
            <div className={styles.section}>
                <SectionTitle className={styles.title}>Avantages</SectionTitle>
                <GridList
                    items={filteredPromotions}
                    cardComponent={PromotionVerticalCard}
                    className={styles.list}
                    autoColumns
                    cardWidth={300}
                />
            </div>
        </div>
    );
}

export default AccountPromotionsPanel;
